export default function () {
  const widgetName = 'headerLogo';
  const widgetOpts = headerLogoOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function (widgetData) {

      let isHCTheme = $(body).hasClass('HC-Theme') ? 1 : 0;
      let headerLogo = `
                      <a 
                        href="${widgetData.items[isHCTheme].URL}" 
                        aria-label="${widgetData.items[isHCTheme].ImageAlternateText}" 
                        style="background-image: url('${widgetData.items[isHCTheme].ImageWithPath}')">
                      </a>`;

      $('.header-logo').append(headerLogo);
      $(`#${widgetName}`).remove();
    },

    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: ['all'],
    maxItemsVisible: 2,
    moreButton: {
      visible: false,
      text: 'Learn More'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false
  });

}